import { render } from "./AccountBar.vue?vue&type=template&id=364f07fe&scoped=true"
import script from "./AccountBar.vue?vue&type=script&lang=js"
export * from "./AccountBar.vue?vue&type=script&lang=js"

import "./AccountBar.vue?vue&type=style&index=0&id=364f07fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-364f07fe"]])

export default __exports__